<template>
  <v-card
    v-if="settings"
    tile
    elevation="0"
    class="py-12 card"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '300px'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <div>
      <title-component :id="id" :settings="{...settingsTitle, idLayout: settings.idLayout}" minHeight="0px" />
    </div>
    
    <div class="cardList">
      <v-card elevation="0" color="transparent" width="1340">
        <v-row
          no-gutters
          class="pt-12"
          justify="center"
          align="stretch"
          :style="{ gap: GAP_CONSTANT }"
        >
          <div 
            v-for="(item, i) in formattedSpeakers" 
            :key="i" 
            @click="handleOpenInfo(item)"
            class="d-flex justify-center"
            :style="{flex: `0 0 calc((100% - (${GAP_CONSTANT} * ${settings['speakers-by-row'] - 1})) / ${settings['speakers-by-row']})`}"
          >
            <component :is="settings.layout.type" :item="item" :settings="settings" @onClickLinkedin="handleOpenLinkedin"/>            
          </div>
        </v-row>

        <v-row
          v-if="speakers && speakers.length > showMoreQuantity"
          no-gutters
          justify="center"
        >
          <v-btn
            :style="
              `
              background-color: ${MIXIN_getStyle(settings, 'button', 'background-color')} !important;
              border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius')} !important;
              `
            "
            rounded
            depressed
            @click="handleClickShowMore"
            >
            <b 
              :style="
                `
                color: ${MIXIN_getStyle(settings, 'button', 'color')} !important;
                `
              "
            >
              {{ settings.buttons[0].caption }}
            </b>
          </v-btn>
        </v-row>
      </v-card>
    </div>

    <Dialog v-model="infoSpeakerDialog" width="740px" hideScrollInContent :persistent="false">
      <template v-if="selectedSpeaker" slot="content">
        <v-row no-gutters class="pb-4">
          <v-col 
            :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12" 
            align-self="center"
          >
            <div class="d-flex justify-center align-center w-100 h-100">
              <img 
                :src="selectedSpeaker.url_avatar" 
                :style="{
                  height: $vuetify.breakpoint.mdAndUp ? '360px' : '280px',
                  'object-position': $vuetify.breakpoint.mdAndUp ? 'none' : 'top'
                }"
              />
            </div>
          </v-col>

          <v-col 
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12" 
            class="pl-6" 
            align-self="center" 
          >
          <h1>{{selectedSpeaker.nome}}</h1>
          <h2>{{selectedSpeaker.cargo}}</h2>
          <h3 class="pb-3">{{selectedSpeaker.empresa}}</h3>
          <div class="about" v-if="selectedSpeaker.sobre">
            {{selectedSpeaker.sobre}}
          </div>

          <div v-if="selectedSpeaker.linkedin" class="d-flex align-center pt-3" style="gap: 24px">
            <span class="text">Acompanhe em suas redes</span>
            <a :href="parseLinkedinUrl(selectedSpeaker.linkedin)" target="_blank" rel="noopener noreferrer">
              <v-btn fab color="transparent" class="elevation-0" x-small>
                <v-icon color="bt_color" size="24">fa-brands fa-linkedin</v-icon>
              </v-btn>
            </a>
          </div>
          </v-col>
        </v-row>
      </template>
    </Dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"
import TitleComponent from "../title/TitleComponent.vue";
import Dialog from '../_v2/ui/Dialog.vue'
import layout1 from './layout/Layout1.vue'
import layout2 from './layout/Layout2.vue'
import layout3 from './layout/Layout3.vue'
import layout4 from './layout/Layout4.vue'
import layout5 from './layout/Layout5.vue'
import layout6 from './layout/Layout6.vue'
import layout7 from './layout/Layout7.vue'
import layout8 from './layout/Layout8.vue'
import layout9 from './layout/Layout9.vue'
import layout10 from './layout/Layout10.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  components: { 
    TitleComponent, 
    Dialog,
    layout1, 
    layout2,
    layout3,
    layout4,
    layout5,
    layout6,
    layout7,
    layout8,
    layout9,
    layout10 
  },
  props: {
    id: {type: String},
    settings: { type: Object }
  },

  data() {
    return {
      settingsTitle: null,
      hover: false,
      showAll: false,
      showMoreQuantity: 0,
      infoSpeakerDialog: false,
      selectedSpeaker: null,
      GAP_CONSTANT: '32px'
    };
  },

  computed: {
    ...mapGetters(["speakers", "infos"]),

    formattedSpeakers() {
      let speakers = [];
      if (!this.speakers) return speakers

      if (
        !this.settings.typeShow ||
        this.settings.typeShow === "" ||
        this.settings.typeShow === "Todos"
      )
        speakers = JSON.parse(JSON.stringify(this.speakers));

      if (
        this.settings.items &&
        this.settings.typeShow &&
        this.settings.typeShow === "Específicos"
      ) {
        speakers = this.settings.items.filter((s) => {
          return s.show;
        });
      }

      if (Number(this.settings["max-speakers"])) {
        let quantityToSlice = Number(this.settings["max-speakers"]);

        if (this.showMoreQuantity) quantityToSlice = this.showMoreQuantity;

        return speakers.slice(0, quantityToSlice);
      }

      return speakers;
    },

    maxSpeakers() {
      return Number(this.settings["max-speakers"]);
    },
  },

  created() {
    this.showMoreQuantity = Number(this.settings["max-speakers"]);

    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },

  methods: {
    handleClickShowMore() {
      this.showMoreQuantity += Number(this.settings["max-speakers"]);
    },

    handleOpenInfo(speaker) {
      this.infoSpeakerDialog = true
      this.selectedSpeaker = speaker
    },

    parseLinkedinUrl(linkedin) {
      if (linkedin.includes('https://www.linkedin.com/in/')) return linkedin
      else return `https://www.linkedin.com/in/${linkedin}`
    },

    handleOpenLinkedin(speaker) {
      if (!speaker.linkedin) return
      const url = this.parseLinkedinUrl(speaker.linkedin)
      window.open(url, '_blank')
    }
  },

  watch: {
    speakers(v) {
      if (v) {
        const copyItems = JSON.parse(JSON.stringify(this.settings.items));
        const isSpecific = this.settings.typeShow === "Específicos";

        this.settings.items = JSON.parse(JSON.stringify(this.speakers)).map((item) => {
          const copy = copyItems.find((copy) => copy.codigo === item.codigo);

          if (copy) return { ...item, show: copy.show };

          return { ...item, show: !isSpecific };
        });

        this.$store.commit('SET_INFOS_COPY', JSON.parse(JSON.stringify(this.infos)))
      }
    },

    maxSpeakers(v) {
      this.showMoreQuantity = v;
    }
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.cardList {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

img {
  width: 100%;
  object-fit: cover;
}

h1 {
  font-size: 24px;
  font-weight: 700;
  line-height: 124%;
}

h2 {
  font-size: 13.5px;
  font-weight: 700;
  line-height: 124%;  
  text-transform: uppercase;
  padding: 4px 0 6px 0;
  color: #0A9AED;
}

h3 {
  font-size: 12px;
  font-weight: 500;
  line-height: 124%;  
  text-transform: uppercase;
}

.about {
  font-size: 13px;
  font-weight: 400;
  color: #666D80;
  overflow-x: hidden;
  overflow-y: auto;  
  max-height: 240px;
}

.about::-webkit-scrollbar {
  width: 8px;
}

.about::-webkit-scrollbar-thumb {
  background-color: rgba(245, 247, 249, 1);
  border-radius: 5px;
}

.about::-webkit-scrollbar-track {
  background-color: white;
}

.text {
  font-size: 13px;
  font-weight: 700
}
</style>
